const colors = {
  baseColor: '#11a3de',
  gradientButton: 'transparent linear-gradient(90deg, #6cd188 0%, #11a3de 100%) 0 0 no-repeat padding-box',
  header: 'linear-gradient(90deg, rgba(101, 201, 126, 1) 0%, rgba(17, 163, 222, 1) 50%);',
  headerLinkActive: '#FFFFFF',
  headerLinkInactive: '#000000',
  headerLinkHover: '#FFFFFF',
  headerButton: '#FFFFFF',
  headerIcon: '#202124',

  red: '#FF0000',
  green: '#65C97E',
  orange: '#DE6811',
  black: '#202124',
  belgian: '#CCB39B',
  grayDark: '#5B6970',
  gray: '#DBDEDE',
  grayLight: '#E6E7E8',
  whiteDark: '#FAFAFA',
  white: '#FFFFFF',
};

export default colors;
